import {useCallback, useEffect, useState} from 'react'
import {backendGetRequest} from '../../../../common/utils/requests'

export type Provider = {
  id: number
  externalId: number
  externalPerformanceFeeAccountId: number | null
  isProviding: boolean
  hasActiveSubscriptions: boolean
  startedAt: string | null
  stoppedAt: string | null
  offer: {
    id: number
    name: string
    externalId: number
    performanceFee: number
  } | null
}

const fetchAPI = async (accountId: number): Promise<{provider: Provider}> => {
  const response = await backendGetRequest(`/api/v2/dashboard/accounts/${accountId}/providers/brokeree`, true)

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Failed to fetch provider ${response.status} ${errorText}`)
  }

  return await response.json()
}

export const useProvider = (accountId: number) => {
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState(true)
  const [provider, setProvider] = useState<Provider | null>(null)

  const fetchData = useCallback(() => {
    fetchAPI(accountId).then((data) => {
      setLoading(false)
      setProvider(data.provider)
    }, (error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching me:', error)
      setLoading(false)
      setError(error)
    })
  }, [accountId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {error, loading, provider, refetch: fetchData}
}
